import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import {
    loadClientSegmentContent,
    loadDefaultClientSegmentContent,
} from 'src/app/store/actions/account-permissions-page.action';
import {
    selectClientSegmentContent,
    selectIsWealthManagementClient,
} from 'src/app/store/selectors/account-permissions.selector';
import { ApiState } from 'src/app/store/state/api.state';
import { ClientSegmentContentDTO } from 'src/common/dtos/client-segment.dto';
import { clientSegmentContentLoadedSuccess } from 'src/app/store/actions/account-permissions-api.action';
import { content } from '../../../content/zci/content';
@Injectable({
    providedIn: 'root',
})
export class ClientSegmentFacadeService {
    private store = inject(Store);


    loadClientSegmentContent(): void {
        this.store.dispatch(loadClientSegmentContent());
    }

    setDefaultClientSegment(): void {
        this.store.dispatch(
            loadDefaultClientSegmentContent({
                data: content.defaultClientSegmentContent,
            }),
        );
    }

    setClientSegmentContent(data: ClientSegmentContentDTO): void {
        this.store.dispatch(clientSegmentContentLoadedSuccess({ data }));
    }

    clientSegmentContent$: Observable<ClientSegmentContentDTO> = this.store
        .select(selectClientSegmentContent)
        .pipe(
            map(({ data }: ApiState<ClientSegmentContentDTO>) => {
                return data;
            }),
        );

    isWealthManagementClient$: Observable<boolean> = this.store.select(
        selectIsWealthManagementClient,
    );
}
